const s=(s,{formDisplayHandler:t,setResponse:e})=>{"subscribed"===s.status?(t(),e({...s,status:"200"})):e(s)};export{s as getResponseStatusHandler};
//# sourceMappingURL=api.js.map
